export const normalize = array => {
    return array.reduce((objects, object) => {
      objects[object.id] = object
      return objects
    }, {})
  }


// WEBPACK FOOTER //
// src/utils/normalize.js